/**
 * TanStack Query hooks for `click-injection-detection-mobile`.
 * Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	getOne,
	list,
	clickInjectionDetectionMobileQueryKeys,
	type CreateClickInjectionDetectionMobileBody,
	type CreateClickInjectionDetectionMobileResponse,
	type ListClickInjectionDetectionMobileResponse,
	type ClickInjectionDetectionMobileEvent,
} from "./api";

export function useClickInjectionDetectionMobileList(): UseQueryResult<
	ListClickInjectionDetectionMobileResponse,
	Error
> {
	return useQuery({
		queryKey: clickInjectionDetectionMobileQueryKeys.list(),
		queryFn: list,
	});
}

export function useClickInjectionDetectionMobileDetail(
	id: string | undefined,
): UseQueryResult<ClickInjectionDetectionMobileEvent, Error> {
	return useQuery({
		queryKey: clickInjectionDetectionMobileQueryKeys.detail(id ?? ""),
		queryFn: () => getOne(id as string),
		enabled: Boolean(id),
	});
}

export function useClickInjectionDetectionMobileCreate(): UseMutationResult<
	CreateClickInjectionDetectionMobileResponse,
	Error,
	CreateClickInjectionDetectionMobileBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: clickInjectionDetectionMobileQueryKeys.all });
		},
	});
}
